import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class DebitOrderNotificationService {

  constructor(private dataService: DataService) { }

  getDebitOrderNotificationList(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/DebitOrderNotification/getDebitOrderNotificationList', searchQuery);
  }
  getSmsDetails(notificationId: number) {
    return this.dataService.getRecord('/api/DebitOrderNotification/getSmsDetails/' + notificationId);
  }
  downloadFile(batchProcessId: number) {
    return this.dataService.getRecord('/api/DebitOrderNotification/downloadfile/' + batchProcessId);
  };

  getFileUploaderInstance  (data) {
    return this.dataService.post('/api/DebitOrderNotification/SaveExcel',data)
  }

  getExcelFileUploaderInstance  () { }

  getProductAndPriceExcelFileUploaderInstance  (data) {
    return this.dataService.post('/api/Report/productAndPriceChange',data)
   } 

   getProdAndPriceChangeRecords() {
    return this.dataService.getRecord('/api/Report/getProdAndPriceChangeRecords')
   } 

  FileUploaderInstance  () { }

  BulkSendRemainderMailToCustomer(data:any){
    return this.dataService.post('/api/Application/BulkSendRemainderMailToCust',data);
  }
  BulkSuspendCustomers(data:any){
     return this.dataService.post('/api/Application/BulkSuspendCustomers',data);
  }
  ProcessBulkRevoke(data:any){
    return this.dataService.post('/api/Application/processBulkRevoke',data);

  }
  bulkpaymentarrangement(data:any){
    return this.dataService.post('/api/Application/uploadBulkPaymentArrangement',data);

  }
}
